import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';
import { moduleConfig } from './config';

export interface ServiceRenewalReminderListItem {
  id: number;
  clientServiceId: number;
  sentAt: string;
  reminderNumber: number | null;
  channel: string | null;
  emailId: number | null;
  renewalResponseStatus: string | null;
  renewalResponseNote: string | null;
  renewalResponseAt: string | null;
  createdById: number | null;
  updatedById: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  clientService?: {
    clientServicetId: number;
    serviceDescr: string | null;
    serviceStartDate: string | null;
    serviceEndDate: string | null;
    serviceCost: number | null;
    serviceInvoice: number | null;
    clientId: number | null;
    client?: { clientId: number; clientName: string | null } | null;
  } | null;
  createdBy?: { id: number; userFirstName: string | null; userLastName: string | null } | null;
  updatedBy?: { id: number; userFirstName: string | null; userLastName: string | null } | null;
}

export const useServiceRenewalReminders = (searchParams?: string) => {
  const queryString = searchParams ? `?${searchParams}` : '';
  const { data, error, isLoading, mutate } = useSWR<ServiceRenewalReminderListItem[]>(
    `${moduleConfig.module.api.list}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data ?? [],
    isLoading,
    error,
    mutate,
  };
};
